import { colors } from '../../../theme/colors';
import {
  Box,
  Collapse,
  Container,
  DialogActions,
  DialogContent,
  DialogTitle,
  Dialog,
  styled,
  IconButton,
  Grid,
  keyframes,
  Typography,
  Button,
} from "@mui/material";
import { Close, Info as InfoIcon, PaddingOutlined } from "@mui/icons-material";

export const InterviewWrapper = styled(Box)({
  maxHeight: "100vh",
  "& .grid-container": {
    backgroundColor: "red",
  },
  "& .candidate_video": {
    transform: "scaleX(-1)",
    position: "absolute",
    height: "calc(100% + 2px)",
    width: "calc(100% + 2px)",
    top: "-1px",
    left: "-1px",
  },
  "& .video-box": {
    minWidth: "448px",
    maxHeight: "252px",
    height: "252px",
    position: "relative",
  },
});

const blink = keyframes`
  to {
    visibility: hidden;
  }
`;

export const MicWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 16px;

  & .blinking {
    animation: ${blink} 1s steps(2, start) infinite;
  }
`;

export const CollapseWrapper = styled(Box)({
  height: "100%",
  "& .drawer_header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    "& > p, svg": {
      color: "#fff",
    },
  },
  "& .drawer_container": {
    height: "100%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },

  "& .header_chat_container": {
    flexGrow: 0,
    display: "flex",
    flexDirection: "column",
  },
  "& .footer__chat--container": {
    display: "flex",
    alignItems: "center",
    padding: "8px",
    borderTop: "1px solid #44444430",
    justifyContent: "right",
  },
});

export const CandidateSectionWrapper = styled(Box)({
  display: "flex",
  height: "100vh",
  flexDirection: "column",
  "& .left-container": {},
});

export const VideoSectionWrapper = styled(Box)({
  "& .Interview__start--countdown1": {
    position: "absolute",
    top: "50%",
    zIndex: 1,
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "white",
    fontSize: "70px",
  },
  "& .face__detection--error": {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    color: "red",
    fontSize: "20px",
    fontWeight: 600,
  },
  "& .al__logo": {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    position: "absolute",
    top: "5px",
    right: "5px",
    border: "4px solid #fff",
  },
});

export const FaceAuthenticationWrapper = styled(Box)({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  marginTop: "50px",
  "&>div": {
    width: "600px",
  },
  "& .capture__camera--icon": {
    fontSize: "30px",
    fill: "white",
    padding: "7px",
    border: "1px solid white",
    borderRadius: "50%",
  },
  "& .capture__camera--container": {
    position: "absolute",
    bottom: 5,
    left: 0,
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
});

export const InterviewOtherWrapper = styled(Grid)({
  backgroundColor: "#f8fafc",
  "& .body__conatiner": {
    padding: "20px 24px",
    height: "90vh",
    width: "100vw",
    background: `linear-gradient(135deg, ${colors.primaryLight} 0%, #f8fafc 50%, ${colors.white} 100%)`,
  },
  "& .video__question__container--grid": {
    height: "90vh",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.06)",
    border: `1px solid ${colors.border.light}`,
    padding: "1.5rem",
    borderRadius: "16px 0px 0px 16px",
    backgroundColor: "#ffffff",
    fontFamily: "inherit",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    audio: {
      display: "none",
    },
  },
  "& .answer__container--grid": {
    height: "90vh",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.06)",
    border: `1px solid ${colors.border.light}`,
    borderLeft: "none",
    padding: "1.5rem 1.5rem 1rem 1.5rem",
    borderRadius: "0px 16px 16px 0px",
    backgroundColor: "#ffffff",
    fontFamily: "inherit",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    audio: {
      display: "none",
    },
  },
  "& .answer__heading": {
    textAlign: "center",
    marginBottom: "1rem",
    padding: "8px",
    fontSize: "20px",
    fontWeight: 600,
    border: `1px solid ${colors.primary}`,

    color: colors.primary,
    borderRadius: "10px",
  },
  "& .answer__container--card": {
    fontFamily: "inherit",
    position: "relative",
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  "& .answer__transcription--typography": {
    fontSize: "15px",
    fontWeight: 600,
    color: colors.text.primary,
    flexGrow: 1,
    overflowY: "auto",
  },
  "& .btn__group": {
    padding: "15px 0px 15px 15px",
    "&::after": {
      content: '""',
      display: "table",
      clear: "both",
    },
  },
  "& .btn__next": {
    float: "right",
    backgroundColor: colors.primary,
    padding: "8px 16px 8px 16px",
    color: colors.white,
    textTransform: "none",
    borderRadius: "8px",
    "&:hover": {
      backgroundColor: colors.primaryHover,
      color: colors.white,
    },
  },
  "& .btn__next.Mui-disabled": {
    backgroundColor: `${colors.buttonDisabled.background} !important`,
    color: `${colors.buttonDisabled.color} !important`,
    opacity: 1,
    cursor: "not-allowed",
  },
  "& .css-1e6y48t-MuiButtonBase-root-MuiButton-root:hover": {
    backgroundColor: colors.primaryHover,
  },
  "& .company__logo": {
    height: "43px",
    width: "auto",
  },
  "& .interview__header--container": {
    padding: "0px 15px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
});

export const DialogTitleStyled = styled(DialogTitle)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  fontWeight: "bold",
  position: "relative",
}));

export const DialogContentStyled = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(3),
  textAlign: "center",
}));

export const DialogActionsStyled = styled(DialogActions)(({ theme }) => ({
  justifyContent: "center",
  padding: "0px 16px 16px 16px",
}));

export const InfoIconStyled = styled(InfoIcon)(({ theme }) => ({
  fontSize: "2rem",
  color: " #fdfeff",
}));

export const CloseButtonStyled = styled(IconButton)(({ theme }) => ({
  position: "absolute",
  right: theme.spacing(1),
  top: theme.spacing(1),
  color: theme.palette.common.white,
}));

export const FullScreenWarningDilogue = styled(Dialog)({
  "& .warning-header": {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    padding: "16px",
    backgroundColor: "#FF2B1C",
  },
  "& .warning-icon": {
    color: "#fff",
  },
  "& .dialog-title": {
    padding: "0px",
    color: "#fff",
    fontWeight: 400,
  },
  "& .dialog-text": {
    fontSize: 16,
  },
  "& .dialog-actions": {
    display: "flex",
    justifyContent: "center",
    padding: "8px 16px 24px",
  },
  "& .fullscreen-button": {
    backgroundColor: "#fff",
    color: "#FF2B1C",
    borderColor: "#FF2B1C",
    "&:hover": {
      backgroundColor: "#FF2B1C",
      color: "#fff",
      borderColor: "#fff",
    },
  },
  "& .fullscreen-icon": {
    marginLeft: "8px",
    fontSize: 30,
  },
});

//---------------------------- InterviewWelcome.js css Start-------------------------
// Animation
const fadeUp = keyframes`
  from { opacity: 0; transform: translateY(25px); }
  to { opacity: 1; transform: translateY(0); }
`;

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(127, 29, 29,0.6); }
  70% { box-shadow: 0 0 0 20px rgba(127, 29, 29,0); }
  100% { box-shadow: 0 0 0 0 rgba(127, 29, 29,0); }
`;

export const WelcomeWrapper = styled(Box)(() => ({
  height: "100vh",
  display: "flex",
  flexDirection: "column",
  background: `linear-gradient(to bottom, ${colors.primaryLight}, ${colors.white})`,
  position: "relative",
  overflowY: "scroll",
  scrollbarWidth: "thin",
  scrollbarColor: `${colors.primary} #f1f1f1`,

  "&::-webkit-scrollbar": {
    width: "8px",
  },

  "&::-webkit-scrollbar-track": {
    background: "#f1f1f1",
    borderRadius: "10px",
  },

  "&::-webkit-scrollbar-thumb": {
    background: colors.primary,
    borderRadius: "10px",
  },

  "&::-webkit-scrollbar-thumb:hover": {
    background: colors.primaryHover,
  },
}));

export const WelcomeViewer = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  flexWrap: "wrap",
  gap: "24px",
  padding: theme.spacing(3),
  background: "#fff",
  boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
  borderRadius: "16px",
  margin: "10px 40px",
  zIndex: "1",
}));
export const RecordedVideoWrapper = styled(Box)(() => ({
  marginTop: "20px",
}));
export const WelcomeInterview = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "flex-start",
  gap: "40px",
  padding: theme.spacing(2),
  [theme.breakpoints.down("md")]: { flexDirection: "column", gap: "24px" },
}));

export const LeftSection = styled(Box)(() => ({
  flex: 1.2,
  display: "flex",
  justifyContent: "flex-start",
  alignItems: "center",
  flexDirection: "column",
}));

export const VideoContainer = styled(Box)(() => ({
  position: "relative",
  width: "100%",
  display: "inline-block",
}));

export const LiveVideo = styled("video")(() => ({
  width: "100%",
  objectFit: "contain",
  borderRadius: "20px",
  background: "#000",
}));

export const RightSection = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  gap: theme.spacing(1),
}));

export const Title = styled(Typography)(() => ({
  fontSize: "2rem",
  fontWeight: 800,
  color: colors.primary,
}));

export const IntroText = styled(Typography)(() => ({
  fontSize: "1rem",
  color: "#333",
  lineHeight: 1.7,
}));

export const CountdownWrapper = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  marginBottom: theme.spacing(0.5),
  padding: theme.spacing(1.5, 2.5),
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  borderRadius: "12px",
  backgroundColor: colors.primaryLight,
  border: "1px solid #fecaca",
  maxWidth: "fit-content",
  "& .countdown_content": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "column",
    gap: "10px",
  },
  "& .countdown_content h6": {
    fontSize: "14px",
    fontWeight: 600,
    color: colors.primary,
    lineHeight: 1.2,
  },
  "& .countdown_content p": {
    fontSize: "13px",
    color: "#5f7387",
  },
}));

export const InterviewWelcomeButton = styled(Button)(() => ({
  backgroundColor: `${colors.primary} !important`,
  color: `${colors.white} !important`,
  borderRadius: "8px",
  fontWeight: 600,
  textTransform: "none",
  boxShadow: "none",
  "&:hover": {
    backgroundColor: `${colors.primaryHover} !important`,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    backgroundColor: `${colors.buttonDisabled.background} !important`,
    color: `${colors.buttonDisabled.color} !important`,
    opacity: 1,
    boxShadow: "none",
    cursor: "not-allowed",
  },
}));

export const RecIndicator = styled(Box)(({ theme }) => ({
  fontSize: "1rem",
  color: "#fff",
  letterSpaceing: "1",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

export const MicIconBadge = styled(Box)(({ recording }) => ({
  position: "absolute",
  bottom: "20px",
  left: "50%",
  width: 75,
  height: 75,
  borderRadius: "50%",
  transform: "translate(-50%)",
  backgroundColor: recording ? "#e53935" : colors.primary,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
  zIndex: 10,
  animation: recording ? `${pulse} 1.5s infinite` : "none",
  transition: "background-color 0.3s ease",
}));

export const RecIconBadge = styled(Box)(({ isrecording }) => ({
  position: "absolute",
  top: "20px",
  right: "20px",
  width: "80px",
  height: "30px",
  backgroundColor: isrecording ? "#e53935" : colors.primary,
  borderRadius: "20px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));
